import { MouseEvent } from "react";
import Button, { ButtonSizeEnum, ButtonTypeEnum } from "../atoms/Button";

export const SignUpBtn = ({
  text,
  onClick,
}: {
  text: string;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
}) => {
  return (
    <Button
      type={ButtonTypeEnum.Primary}
      size={ButtonSizeEnum.Small}
      onClick={onClick}
      clickId="signup-button"
    >
      {text}
    </Button>
  );
};
